module.exports = __webpack_public_path__ + "img/icon_arrow_down@2x.f00658bd.png";